<template>
  <div>
    <vxe-form
        :data="formData"
        :rules="formRules"
        title-colon
        ref="xForm"
        title-width="200"
        title-align="right"
    >
      <vxe-form-item span="24">
        <template>
          <div class="block">
            <div class="block-tip"></div>
            <span class="block-title">基本信息</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="原始单号" field="originalDocumentNumber" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.originalDocumentNumber }}</span>
          <vxe-input
              v-model="formData.originalDocumentNumber"
              placeholder="请输入原始单号"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="运单号" field="shippingNoteNumber" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.shippingNoteNumber }}</span>
          <vxe-input
              v-model="formData.shippingNoteNumber"
              placeholder="请输入运单号"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="分段分单号" field="serialNumber" span="8">
        <template>
          <span>{{ formData.serialNumber }}</span>
        </template>
      </vxe-form-item>

      <vxe-form-item title="运输总车辆数" field="vehicleAmount" span="8">
        <template>
          <span>{{ formData.vehicleAmount }}</span>
        </template>
      </vxe-form-item>
      <vxe-form-item title="运输组织类型" field="transportTypeCode" span="8">
        <template>
          <span v-if="!isEdit">{{ formData.transportTypeCodeText }}</span>
          <vxe-select v-else v-model="formData.transportTypeCode" transfer>
            <vxe-option v-for="(item,index) in transport_type_code" :key="index" :value="item.value"
                        :label="item.label"></vxe-option>
          </vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="业务类型代码" field="businessTypeCode" span="8">
        <template>
          <span v-if="!isEdit">{{ formData.businessTypeCodeText }}</span>
          <vxe-select v-else v-model="formData.businessTypeCode" transfer>
            <vxe-option v-for="(item,index) in business_type_code" :key="index" :value="item.value"
                        :label="item.label"></vxe-option>
          </vxe-select>
        </template>
      </vxe-form-item>

      <vxe-form-item title="网络货运经营者" field="carrier" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.carrier }}</span>
          <vxe-input
              v-model="formData.carrier"
              placeholder="请输入网络货运经营者"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item
          title="统一社会信用代码"
          field="unifiedSocialCreditIdentifier"
          span="8"
      >
        <template #default="scope">
          <span v-if="!isEdit">{{
            formData.unifiedSocialCreditIdentifier
          }}</span>
          <vxe-input
              v-model="formData.unifiedSocialCreditIdentifier"
              placeholder="请输入统一社会信用代码"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item
          title="道路运输经营许可证编号"
          field="permitNumber"
          span="8"
      >
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.permitNumber }}</span>
          <vxe-input
              v-model="formData.permitNumber"
              placeholder="请输入道路运输经营许可证编号"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>

      <vxe-form-item title="运单生成时间" field="consignmentDateTime" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.consignmentDateTime }}</span>
          <vxe-input
              v-model="formData.consignmentDateTime"
              type="datetime" placeholder="请选择运单生成时间"
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="运单上传时间" field="sendToProDateTime" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.sendToProDateTime }}</span>
          <vxe-input
              v-model="formData.sendToProDateTime"
              type="datetime" placeholder="请选择运单上传时间"
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>

      <vxe-form-item span="24">
        <template>
          <div class="block">
            <div class="block-tip"></div>
            <span class="block-title">收发货信息</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="托运人名称" field="consignor" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.consignor }}</span>
          <vxe-input
              v-model="formData.consignor"
              placeholder="请输入托运人名称"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="托运人证件号" field="consignorId" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.consignorId }}</span>
          <vxe-input
              v-model="formData.consignorId"
              placeholder="请输入托运人证件号"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="运费金额(元)" field="totalMonetaryAmount" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.totalMonetaryAmount }}</span>
          <vxe-input
              v-model="formData.totalMonetaryAmount"
              placeholder="请输入运费金额"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="装货地" field="placeOfLoading" span="8">
        <template>
          <span v-if="!isEdit">{{ formData.placeOfLoadingText }}</span>
          <Cascader
              v-else
              placeholder="请选择省市区"
              :data="cityData"
              v-model="formData.placeOfLoading"
              transfer
          ></Cascader>
        </template>
      </vxe-form-item>
      <vxe-form-item title="详细地址" field="placeOfLoadingDetail" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.placeOfLoadingDetail }}</span>
          <vxe-input
              v-model="formData.placeOfLoadingDetail"
              placeholder="请输入详细地址"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="发货时间" field="despatchActualDateTime" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.despatchActualDateTime }}</span>
          <vxe-input
              v-model="formData.despatchActualDateTime"
              type="datetime" placeholder="请选择发货时间"
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>

      <vxe-form-item title="收货方名称" field="consignee" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.consignee }}</span>
          <vxe-input
              v-model="formData.consignee"
              placeholder="请输入收货方名称"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="收货人证件号" field="consigneeId" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.consigneeId }}</span>
          <vxe-input
              v-model="formData.consigneeId"
              placeholder="请输入收货人证件号"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="8">
      </vxe-form-item>

      <vxe-form-item title="收货地" field="goodsReceiptPlace" span="8">
        <template>
          <span v-if="!isEdit">{{ formData.goodsReceiptPlaceText }}</span>
          <Cascader
              :data="cityData"
              placeholder="请选择省市区"
              v-model="formData.goodsReceiptPlace"
              v-else
              transfer
          ></Cascader>
        </template>
      </vxe-form-item>
      <vxe-form-item title="详细地址" field="goodsReceiptPlaceDetail" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.goodsReceiptPlaceDetail }}</span>
          <vxe-input
              v-model="formData.goodsReceiptPlaceDetail"
              placeholder="请输入详细地址"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="收货时间" field="goodsReceiptDateTime" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.goodsReceiptDateTime }}</span>
          <vxe-input
              v-model="formData.goodsReceiptDateTime"
              type="datetime" placeholder="请选择收货时间"
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>

      <vxe-form-item span="24">
        <template>
          <div class="block">
            <div class="block-tip"></div>
            <span class="block-title">车辆司机信息</span>
          </div>
        </template>
      </vxe-form-item>

      <vxe-form-item title="车牌号" field="vehicleNumber" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.vehicleNumber }}</span>
          <vxe-input
              v-model="formData.vehicleNumber"
              placeholder="请输入车牌号"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车牌颜色" field="vehiclePlateColorCode" span="8">
        <template>
          <span v-if="!isEdit">{{ formData.vehiclePlateColorCodeText }}</span>
          <vxe-select v-else v-model="formData.vehiclePlateColorCode"
                      @change="$refs.xForm.clearValidate('vehiclePlateColorCode');" transfer>
            <vxe-option v-for="(item,index) in vehicle_plate_color_code" :key="index" :value="item.value"
                        :label="item.label"></vxe-option>
          </vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="核定载质量(吨)" field="deadweight" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.deadweight }}</span>
          <vxe-input
              v-model="formData.deadweight"
              placeholder="请输入核定载质量"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>

      <vxe-form-item title="实际承运人名称" field="actualCarrierName" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.actualCarrierName }}</span>
          <vxe-input
              v-model="formData.actualCarrierName"
              placeholder="请输入实际承运人名称"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="道路运输经营许可证" field="actualCarrierBusinessLicense" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.actualCarrierBusinessLicense }}</span>
          <vxe-input
              v-model="formData.actualCarrierBusinessLicense"
              placeholder="请输入道路运输经营许可证"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="实际承运人证件号" field="actualCarrierId" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.actualCarrierId }}</span>
          <vxe-input
              v-model="formData.actualCarrierId"
              placeholder="请输入实际承运人证件号"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>

      <vxe-form-item title="驾驶员姓名" field="driverName" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.driverName }}</span>
          <vxe-input
              v-model="formData.driverName"
              placeholder="请输入驾驶员姓名"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="驾驶员身份证" field="drivingLicense" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.drivingLicense }}</span>
          <vxe-input
              v-model="formData.drivingLicense"
              placeholder="请输入驾驶员身份证"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="8">
      </vxe-form-item>

      <vxe-form-item title="保险公司" field="insuranceCompanyCode" span="8">
        <template>
          <span v-if="!isEdit">{{ formData.insuranceCompanyCodeText }}</span>
          <vxe-select v-else v-model="formData.insuranceCompanyCode" transfer>
            <vxe-option v-for="(item,index) in insurance_company_code" :key="index" :value="item.value"
                        :label="item.label"></vxe-option>
          </vxe-select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="保险单号" field="policyNumber" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.policyNumber }}</span>
          <vxe-input
              v-model="formData.policyNumber"
              placeholder="请输入保险单号"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="备注" field="remark" span="8">
        <template #default="scope">
          <span v-if="!isEdit">{{ formData.remark }}</span>
          <vxe-input
              v-model="formData.remark"
              placeholder="请输入内容"
              clearable
              @input="$refs.xForm.updateStatus(scope)"
              v-else
          ></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="block">
      <div class="block-tip"></div>
      <span class="block-title">货物信息</span>
    </div>
    <div class="add-box clearfix">
      <vxe-table
          border
          show-overflow
          ref="xTable2"
          class="table-style"
          max-height="480"
          :auto-resize="true"
          align="center"
          :data="goodsList"
          :edit-rules="tableRules"
      >
        <vxe-table-column field="descriptionOfGoods" title="货物名称">
          <template v-slot:header>
            <span style="color: red">*</span>货物名称
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.descriptionOfGoods" placeholder="请输入"
                       @blur="clearV2"></vxe-input>
            <span v-else>{{scope.row.descriptionOfGoods}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="cargoTypeClassificationCode" title="货物类型">
          <template v-slot:header>
            <span style="color: red">*</span>货物类型
          </template>
          <template v-slot="scope">
            <vxe-select v-if="isEdit" v-model="scope.row.cargoTypeClassificationCode" transfer>
              <vxe-option v-for="(item,index) in goods_type_code" :key="index" :value="item.value"
                          :label="item.label"></vxe-option>
            </vxe-select>
            <span v-else>{{ scope.row.cargoTypeClassificationCodeText }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsItemGrossWeight" title="货物项毛重(kg)">
          <template v-slot:header>
            <span style="color: red">*</span>货物项毛重(kg)
          </template>
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.goodsItemGrossWeight" placeholder="请输入货物项毛重"
                       @blur="clearV2"></vxe-input>
            <span v-else>{{scope.row.goodsItemGrossWeight}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="cube" title="体积(m²)">
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.cube" placeholder="请输入体积" @blur="clearV2"></vxe-input>
            <span v-else>{{scope.row.cube}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="totalNumberOfPackages" title="总件数">
          <template v-slot="scope">
            <vxe-input v-if="isEdit" v-model="scope.row.totalNumberOfPackages" placeholder="请输入总件数"
                       @blur="clearV2"></vxe-input>
            <span v-else>{{scope.row.totalNumberOfPackages}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class=" add-btn-box">
      <Button v-if="!isEdit && isHavePermission('eleWaybill:edit')" type="primary" @click="goEdit" style="width: 100px;">编 辑</Button>
      <Button v-if="isEdit" @click="cancel" style="width: 100px;">取 消</Button>
      <Button v-if="isEdit" type="primary" style="width: 100px;" @click="updateLogistics">确 定</Button>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import {isNotEmpty} from "@/utils/util";
  import getAuthOrization from "@/mixin/getAuthOrization";

  export default {
    props: ['cityData', 'business_type_code', 'insurance_company_code', 'transport_type_code', 'goods_type_code', 'vehicle_plate_color_code'],
    mixins: [getAuthOrization],
    data() {
      return {
        formData: {
          goodsReceiptPlaceText: '',
          placeOfLoadingText: '',
          businessTypeCodeText: '',
          vehiclePlateColorText: '',
          insuranceCompanyCodeText: '',
          transportTypeCodeText: '',
          cargoTypeClassificationCodeText: '',
          originalDocumentNumber: null, // 原始单号
          shippingNoteNumber: null, // 运单号
          serialNumber: null, //分段分单号
          vehicleAmount: null, //运输总车辆数
          transportTypeCode: null, // 运输组织类型
          businessTypeCode: null, // 业务类型代码
          carrier: null, // 网络货运经营者
          unifiedSocialCreditIdentifier: null, // 统一社会信用代码
          permitNumber: null, // 道路运输经营许可证编号
          consignmentDateTime: null, //运单生成时间
          sendToProDateTime: null, // 运单上传时间
          consignor: null, // 托运人名称
          consignorId: null, // 托运人证件号
          totalMonetaryAmount: null, // 运费金额
          placeOfLoading: [], // 装货地
          placeOfLoadingDetail: null, // 装货地详细地址
          despatchActualDateTime: null, // 发货时间
          consignee: null, // 收货方名称
          consigneeId: null, //收货人证件号
          goodsReceiptPlace: [], // 收货地
          goodsReceiptPlaceDetail: null, // 收货地详细地址
          goodsReceiptDateTime: null, // 收货时间
          vehicleNumber: null, // 车牌号
          vehiclePlateColorCode: null, // 车牌颜色
          deadweight: null, // 核定载质量
          actualCarrierName: null, //实际承运人名称
          actualCarrierBusinessLicense: null, //道路运输经营许可证
          actualCarrierId: null, // 实际承运人证件号
          driverName: null, // 驾驶员姓名
          drivingLicense: null, // 驾驶员身份证
          insuranceCompanyCode: null, //保险公司
          policyNumber: null, // 保险单号
          remark: null, // 备注
        },
        formRules: {
          originalDocumentNumber: [{required: true, message: "请输入原始单号"}],
          shippingNoteNumber: [{required: true, message: "请输入运单号"}],
          serialNumber: [{required: true, message: "请输入分段分单号"}],
          vehicleAmount: [{required: true, message: "请输入运输总车辆数"}],
          transportTypeCode: [{required: true, message: "请选择运输组织类型"}],
          businessTypeCode: [{required: true, message: "请选择业务类型代码"}],
          carrier: [{required: true, message: "请输入网络货运经营者"}],
          unifiedSocialCreditIdentifier: [
            {required: true, message: "请输入统一社会信用代码"},
          ],
          permitNumber: [
            {required: true, message: "请输入道路运输经营许可证编号"},
          ],
          consignmentDateTime: [
            {required: true, message: "请选择运单生成时间"},
          ],
          // sendToProDateTime: [{required: true, message: "请选择运单上传时间"}],
          consignor: [{required: true, message: "请输入托运人名称"}],
          consignorId: [{required: true, message: "请输入托运人证件号"}],
          totalMonetaryAmount: [{required: true, message: "请输入运费金额"}],
          placeOfLoading: [{required: true, message: "请选择装货地"}],
          placeOfLoadingDetail: [{required: true, message: "请输入装货地详细地址"}],
          despatchActualDateTime: [{required: true, message: "请选择发货时间"}],
          consignee: [{required: true, message: "请输入收货方名称"}],
          // consigneeId: [{required: true, message: "请输入收货人证件号"}],
          goodsReceiptPlace: [{required: true, message: "请选择收货地"}],
          goodsReceiptPlaceDetail: [{required: true, message: "请输入收货地详细地址"}],
          goodsReceiptDateTime: [{required: true, message: "请选择收货时间"}],
          vehicleNumber: [{required: true, message: "请输入车牌号"}],
          vehiclePlateColorCode: [{required: true, message: "请选择车牌颜色"}],
          deadweight: [{required: true, message: "请输入核定载质量"}],
          actualCarrierName: [{required: true, message: "请输入实际承运人名称"}],
          actualCarrierBusinessLicense: [{required: true, message: "请输入道路运输经营许可证"}],
          actualCarrierId: [{required: true, message: "请输入实际承运人证件号"}],
          driverName: [{required: true, message: "请输入驾驶员姓名"}],
          drivingLicense: [{required: true, message: "请输入驾驶员身份证"}],
          // insuranceCompanyCode: [{required: true, message: "请输入保险公司"}],
          // policyNumber: [{required: true, message: "请输入保险单号"}],
          // remark: [{required: true, message: "请输入备注"}],
        },
        tableRules: {
          descriptionOfGoods: [{required: true, message: "请输入货物名称"}],
          cargoTypeClassificationCode: [{required: true, message: "请选择货物类型"}],
          goodsItemGrossWeight: [{required: true, message: "请输入货物项毛重"}],
        },
        isEdit: false,
        goodsList: [],
        id: null
      };
    },
    mounted() {
    },
    methods: {
      generateTimeReqestNumber(date) {
        return date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2(date.getDate()) + this.pad2(date.getHours()) + this.pad2(date.getMinutes()) + this.pad2(date.getSeconds());
      },
      pad2(n) {
        return n < 10 ? '0' + n : n
      },
      async validEvent() {
        let errMap = await this.$refs.xForm
          .validate()
          .catch((errMap) => errMap);
        if (!errMap) {
          errMap = await this.$refs.xTable2.validate().catch((errMap) => errMap);
        }
        return errMap ? false : true;
      },
      clearV() {
        this.$refs.xForm.clearValidate();
      },
      clearV2() {
        this.$refs.xTable2.clearValidate();
      },
      cancel() {
        this.isEdit = false;
        this.clearV();
        this.clearV2();
      },
      showDetail(id) {
        if (!this.isHavePermission('logistics:queryLogisticsDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.id = id;
        this.isEdit = false;
        this.queryLogisticsDetail(id);
      },
      setUpdate(id) {
        if (!this.isHavePermission('logistics:queryLogisticsDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.id = id;
        this.isEdit = true;
        this.queryLogisticsDetail(id);
      },
      async updateLogistics() {
        let sts = await this.validEvent();
        if (!sts) {
          return;
        }

        let obj = Object.assign({}, this.formData);

        if (this.formData.despatchActualDateTime) {
          obj.despatchActualDateTime = this.generateTimeReqestNumber(this.$utils.toStringDate(this.formData.despatchActualDateTime));
        }
        if (this.formData.goodsReceiptDateTime) {
          obj.goodsReceiptDateTime = this.generateTimeReqestNumber(this.$utils.toStringDate(this.formData.goodsReceiptDateTime));
        }
        if (this.formData.sendToProDateTime) {
          obj.sendToProDateTime = this.generateTimeReqestNumber(this.$utils.toStringDate(this.formData.sendToProDateTime));
        }
        if (this.formData.consignmentDateTime) {
          obj.consignmentDateTime = this.generateTimeReqestNumber(this.$utils.toStringDate(this.formData.consignmentDateTime));
        }

        obj.id = this.id;
        obj.descriptionOfGoods = this.goodsList[0].descriptionOfGoods;
        obj.cargoTypeClassificationCode = this.goodsList[0].cargoTypeClassificationCode;
        obj.goodsItemGrossWeight = this.goodsList[0].goodsItemGrossWeight;
        obj.cube = this.goodsList[0].cube;
        obj.totalNumberOfPackages = this.goodsList[0].totalNumberOfPackages;

        obj.placeOfLoading = isNotEmpty(this.formData.placeOfLoading) ? this.formData.placeOfLoading.join(",") : "";
        obj.goodsReceiptPlace = isNotEmpty(this.formData.goodsReceiptPlace) ? this.formData.goodsReceiptPlace.join(",") : "";

        let res = await $api.reportData.post('updateLogistics', obj);
        if (res.status === 1) {
          this.$Message.success("修改成功");
          this.reset();
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async queryLogisticsDetail(id) {
        this.clearV();
        this.clearV2();
        let res = await $api.reportData.post('queryLogisticsDetail', {
          id: id
        });
        if (res.status === 1) {
          let data = res.data;
          let despatchActualDateTime = null;
          let goodsReceiptDateTime = null;
          let sendToProDateTime = null;
          let consignmentDateTime = null;
          if (data.despatchActualDateTime) {
            despatchActualDateTime = this.strDate(data.despatchActualDateTime);
          }
          if (data.goodsReceiptDateTime) {
            goodsReceiptDateTime = this.strDate(data.goodsReceiptDateTime);
          }
          if (data.sendToProDateTime) {
            sendToProDateTime = this.strDate(data.sendToProDateTime);
          }
          if (data.consignmentDateTime) {
            consignmentDateTime = this.strDate(data.consignmentDateTime);
          }

          let goodsReceiptPlace;
          let placeOfLoading;
          let goodsReceiptPlaceText = '';
          let placeOfLoadingText = '';

          if (data.placeOfLoading) {
            if (Array.isArray(data.placeOfLoading)) {
              placeOfLoading = data.placeOfLoading;
            } else {
              placeOfLoading = data.placeOfLoading.split(",");
              placeOfLoading.map(i => {
                placeOfLoadingText = placeOfLoadingText + '/' + i;
              })
            }
          } else {
            placeOfLoading = [];
          }
          if (data.goodsReceiptPlace) {
            if (Array.isArray(data.goodsReceiptPlace)) {
              goodsReceiptPlace = data.goodsReceiptPlace;
            } else {
              goodsReceiptPlace = data.goodsReceiptPlace.split(",");
              goodsReceiptPlace.map(i => {
                goodsReceiptPlaceText = goodsReceiptPlaceText + '/' + i;
              })
            }
          } else {
            goodsReceiptPlace = [];
          }
          data.goodsReceiptPlace = goodsReceiptPlace;
          data.placeOfLoading = placeOfLoading;
          data.placeOfLoadingText = placeOfLoadingText.substr(1);
          data.goodsReceiptPlaceText = goodsReceiptPlaceText.substr(1);

          this.business_type_code.map(i => {
            if (data.businessTypeCode === i.value) {
              data.businessTypeCodeText = i.label;
            }
          })
          this.insurance_company_code.map(i => {
            if (data.insuranceCompanyCode === i.value) {
              data.insuranceCompanyCodeText = i.label;
            }
          })
          this.transport_type_code.map(i => {
            if (data.transportTypeCode === i.value) {
              data.transportTypeCodeText = i.label;
            }
          })
          this.goods_type_code.map(i => {
            if (data.cargoTypeClassificationCode === i.value) {
              data.cargoTypeClassificationCodeText = i.label;
            }
          })
          this.vehicle_plate_color_code.map(i => {
            if (data.vehiclePlateColorCode === i.value) {
              data.vehiclePlateColorCodeText = i.label;
            }
          })

          this.formData = data;
          this.formData.despatchActualDateTime = despatchActualDateTime ? this.$utils.toDateString(new Date(despatchActualDateTime), "yyyy-MM-dd HH:mm:ss") : null;
          this.formData.goodsReceiptDateTime = goodsReceiptDateTime ? this.$utils.toDateString(new Date(goodsReceiptDateTime), "yyyy-MM-dd HH:mm:ss") : null;
          this.formData.sendToProDateTime = sendToProDateTime ? this.$utils.toDateString(new Date(sendToProDateTime), "yyyy-MM-dd HH:mm:ss") : null;
          this.formData.consignmentDateTime = consignmentDateTime ? this.$utils.toDateString(new Date(consignmentDateTime), "yyyy-MM-dd HH:mm:ss") : null;

          this.goodsList = [{
            descriptionOfGoods: data.descriptionOfGoods,
            cargoTypeClassificationCode: data.cargoTypeClassificationCode,
            cargoTypeClassificationCodeText: data.cargoTypeClassificationCodeText,
            goodsItemGrossWeight: data.goodsItemGrossWeight,
            cube: data.cube,
            totalNumberOfPackages: data.totalNumberOfPackages
          }];
        }
      },
      strDate(dateString) {
        const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
        return new Date(dateString.replace(pattern, '$1/$2/$3 $4:$5:$6'));
      },
      reset() {
        this.formData = {
          goodsReceiptPlaceText: '',
          placeOfLoadingText: '',
          businessTypeCodeText: '',
          vehiclePlateColorText: '',
          insuranceCompanyCodeText: '',
          transportTypeCodeText: '',
          cargoTypeClassificationCodeText: '',
          originalDocumentNumber: null, // 原始单号
          shippingNoteNumber: null, // 运单号
          serialNumber: null, //分段分单号
          vehicleAmount: null, //运输总车辆数
          transportTypeCode: null, // 运输组织类型
          businessTypeCode: null, // 业务类型代码
          carrier: null, // 网络货运经营者
          unifiedSocialCreditIdentifier: null, // 统一社会信用代码
          permitNumber: null, // 道路运输经营许可证编号
          consignmentDateTime: null, //运单生成时间
          sendToProDateTime: null, // 运单上传时间
          consignor: null, // 托运人名称
          consignorId: null, // 托运人证件号
          totalMonetaryAmount: null, // 运费金额
          placeOfLoading: [], // 装货地
          placeOfLoadingDetail: null, // 装货地详细地址
          despatchActualDateTime: null, // 发货时间
          consignee: null, // 收货方名称
          consigneeId: null, //收货人证件号
          goodsReceiptPlace: [], // 收货地
          goodsReceiptPlaceDetail: null, // 收货地详细地址
          goodsReceiptDateTime: null, // 收货时间
          vehicleNumber: null, // 车牌号
          vehiclePlateColorCode: null, // 车牌颜色
          deadweight: null, // 核定载质量
          actualCarrierName: null, //实际承运人名称
          actualCarrierBusinessLicense: null, //道路运输经营许可证
          actualCarrierId: null, // 实际承运人证件号
          driverName: null, // 驾驶员姓名
          drivingLicense: null, // 驾驶员身份证
          insuranceCompanyCode: null, //保险公司
          policyNumber: null, // 保险单号
          remark: null, // 备注
        };
        this.goodsList = [];
        this.id = null;
        this.isEdit = false;
      },
      goEdit() {
        this.isEdit = true;
      },
    },
  };
</script>

<style scoped>
  .block {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }

  .block-tip {
    width: 4px;
    height: 16px;
    background: #539fff;
  }

  .block-title {
    margin-left: 4px;
    height: 21px;
    font-size: 16px;
    font-weight: bold;
    line-height: 21px;
    color: #539fff;
  }

  .modal-footer {
    box-sizing: border-box;
    padding: 10px 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 98%;
    position: absolute;
    bottom: 0;
  }
</style>